<template>
  <div>
    <v-row>
      <v-col cols="6" sm="3" md="2">
        <v-text-field dense outlined label="LCBO Product #" v-model="product.provincialDetails.number"/>
      </v-col>
      <v-col cols="6" sm="3" md="2">
        <v-autocomplete dense outlined label="LCBO Category" v-model="product.provincialDetails.category"
                   hint="For LCBO reporting" persistent-hint
                  :rules="[fieldRules.required]"
                  :items="[{text:'Whisky',value:'W'},{text:'Rum',value:'R'},{text:'Gin',value:'G'},{text:'Vodka',value:'V'},
                           {text:'Liqueur',value:'L'},{text:'Brandy',value:'B'},{text:'One pour/Pre-mix cocktails',value:'P'},
                           {text:'Coolers',value:'C'},
                           {divider:true},{text:'Bitters',value:'X'}]"/>
      </v-col>
    </v-row>
   </div>
</template>

<script>

export default {
  name: 'Info',
  props: {
    product: {type:Object, required:true}
  }
}
</script>